module.exports = __webpack_public_path__ + "media/img/events/location/car-f46ffddd09582af0820dd12b641151dc.svg";